// extracted by mini-css-extract-plugin
export default {"header":"reassignMerchants_header__2HmJ2","title":"reassignMerchants_title__-f+5E","body":"reassignMerchants_body__7lwXr","footer":"reassignMerchants_footer__XD4oY"};